import { MediaMatcher } from '@angular/cdk/layout';
import { Component, Output, EventEmitter } from '@angular/core';

import { AppConstant } from '@app/app.constants';
import { MenuLink } from './nav-list.model';

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrls: ['./nav-list.component.scss'],
  providers: [AppConstant]
})
export class NavListComponent {
  @Output() sidenavClose = new EventEmitter();

  menuLinks: MenuLink[] = [
    {
      label: 'Home',
      url: '/home'
    },
    {
      label: 'Data QC',
      url: '/data-qc'
    },
    {
      label: 'Masking QC',
      url: '/masking-qc'
    },
    {
      label: 'Spectral Overview',
      url: '/spectral-overview'
    },
    {
      label: 'Mineral ID',
      url: '/mineral-id'
    },
    {
      label: 'Batch',
      url: '/batch'
    },
    {
      label: 'Reporting',
      url: '/reporting'
    },
  ];

  constructor(private mediaMatch: MediaMatcher, private appConstant: AppConstant) {}

  onSidenavClose = () => {
    this.sidenavClose.emit();
  };

  onLinkClick() {
    const mobileQuery: MediaQueryList = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);
    // If mobile resolution, close the sidenav
    if (mobileQuery?.matches) {
      this.sidenavClose.emit();
    }
  }
}
